import { h } from 'vue';

export const CircleWithCheckbox = (light: boolean, radius: string) => h('svg', {
    width: '32',
    height: '32',
    version: '1.1',
    viewBox: '0 0 8.47 8.47',
    style: {
        width: radius,
        height: radius,
    }
}, h('g', {
    fill: 'none',
    stroke: light ? 'var(--brand)' : 'var(--brand-d2)',
    'stroke-miterlimit': '2.1',
    'stroke-width': '.2',
}, [
    h('circle', {
        cx: '4.23',
        cy: '4.23',
        r: '4.1',
    }),
    h('path', {
        d: 'm2.62 4.45 1.32 1.06 2.12-2.38',
    }),
]));
